import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from "@angular/core";

@Component({
  selector: 'app-simple-popin',
  templateUrl: './simple-popin.component.html',
  styleUrls: ['./simple-popin.component.scss']
})
export class SimplePopinComponent implements OnInit {

  constructor() { }
  @Input() content: TemplateRef<any>;
  @Input() buttons: TemplateRef<any>

  @Output() closed = new EventEmitter<any>();

  ngOnInit(): void {
  }

  doClose() {
    this.closed.emit();
  }
}
